
import { CONSTANTS } from '../../common/constants';
import { TASK_CONSTANTS } from "../../common/task.constants";
import { clusterService } from '../../services/cluster.service';
import { taskService } from '../../services/task.service';
import { STORE_CONSTANTS } from '../../common/store.constants';
import { reject } from 'lodash';
import { searchHistoryService } from "../../services/searchHistory.service";

const ACTION_NAMES = STORE_CONSTANTS.ALL_TASKS.ACTIONS.WITHOUT_NAMESPACE;
const MUTATION_NAMES = STORE_CONSTANTS.ALL_TASKS.MUTATIONS.WITHOUT_NAMESPACE;

const allTasks = {
    namespaced: true,
    actions: {
        /**
         * Gets tasks across project staff based on the search criteria entered and returns the results
         * after first saving them in the store
         * @param {*} context - store context
         * @param {*} criteria - search criteria
         * @returns
         */
        getTasksGeneral(context, criteria) {
            context.commit(MUTATION_NAMES.SET_IS_EXECUTING, true);
            return new Promise((resolve, reject) => {
                let tasks = [];
                taskService.getTasksGeneral(criteria).then(function (response) {
                    if (response && response.data) {
                        tasks = response.data;
                    }
                    context.commit(MUTATION_NAMES.SET_TASKS, tasks);
                    resolve({ selectedRow: tasks[0], tasksCount: tasks.length });
                })
                .catch(function (err) {
                    reject(err);
                })
                .finally(() => {
                    context.commit(MUTATION_NAMES.SET_IS_EXECUTING, false);
                });
            });
        },
      	setSelectedTask (context, selectedTask) {
            return new Promise((resolve) => {
                context.commit(MUTATION_NAMES.SET_SELECTED_TASK, selectedTask);
                // Clear task tracks
                context.dispatch('tracks/clearTaskTracks', {}, { root: true }).then((results) => {
                    resolve({});
                })
                .catch((err) => {
                    reject(err);
                });
            });
        }
    },
    getters: {
        getTasks: (state) => {
            return state.tasks;
        },
        getTaskCount: (state) => {
            if (!state.tasks) {
                return 0;
            }
            return state.tasks.length;
        }
    },
    mutations: {
			setTasks (state, tasks) {
					// Vue.set(state, 'tasks', tasks);
					state.tasks = tasks
			},
			setSelectedTask (state, selectedTask) {
					// Vue.set(state, 'selectedTask', selectedTask);
					state.selectedTask = selectedTask
			},
			setIsExecuting (state, isExecuting) {
					// Vue.set(state, 'isExecuting', isExecuting);
					state.isExecuting = isExecuting
			}
	},
    store: {
        tasks: [],
        selectedTask: null,
        isExecuting: false
    }
};

export default allTasks;
